module.exports = __webpack_public_path__ + "img/success.b5c504a5.png";